import React from "react";
import { Button, Card } from "react-bootstrap";
import { TariffPlanVm } from "../interface";

interface TariffPlanCardProps {
    plan: TariffPlanVm;
    onClickAction?: (plan: TariffPlanVm) => void;
    canManageSubscription?: boolean;
}

const TariffPlanCard: React.FC<TariffPlanCardProps> = ({ plan, onClickAction, canManageSubscription = true }) => {
    const isActionDisabled = !!plan.action?.disabled || !canManageSubscription;

    return (
        <Card className="rounded-4 h-100">
            <Card.Body
                className={`p-4 d-flex flex-column p-4 rounded-4 h-100 ${plan.isPremium ? "tariffPlanCard--premium" : "border border-secondary"}`}
            >
                <div style={{ minHeight: 106 }}>
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-1 mb-2 ">
                        <div className="fs-20">{plan.title}</div>
                        <div className="text-nowrap">
                            <span className="fw-bold fs-24">{plan.displayPriceText}</span>
                            <span className="fs-7 text-grey">{plan.periodSuffixText}</span>
                        </div>
                    </div>
                    <div
                        className={`d-flex  ${plan.saveText ? "justify-content-between gap-2" : "justify-content-end"}`}
                    >
                        {plan.saveText ? (
                            <span className="d-inline-block fs-7">
                                <i className="bi bi-tag-fill text-orange me-1" />
                                <span>{plan.saveText}</span>
                            </span>
                        ) : null}
                        {plan.billedText ? <div className="fs-7 text-grey text-nowrap">{plan.billedText}</div> : null}
                    </div>
                </div>
                <div className="d-none d-lg-block">
                    {plan.rows.map((row, index) => (
                        <div
                            key={row.id}
                            className={`py-2 text-center ${index !== plan.rows.length - 1 ? "border-bottom" : ""} ${
                                row.isEmphasis ? "fw-bold" : ""
                            }`}
                        >
                            {row.value}
                        </div>
                    ))}
                </div>

                <div className="d-lg-none">
                    {plan.rows.map((row, index) => (
                        <div
                            key={row.id}
                            className={`d-flex justify-content-between gap-3 py-2 ${
                                index !== plan.rows.length - 1 ? "border-bottom" : ""
                            }`}
                        >
                            <span className="text-muted small">{row.label}</span>
                            <span className={`text-end ${row.isEmphasis ? "fw-semibold" : ""}`}>{row.value}</span>
                        </div>
                    ))}
                </div>

                <div className="mt-auto pt-4">
                    {plan.hideAction ? (
                        <div style={{ minHeight: 38 }} />
                    ) : plan.action ? (
                        <Button
                            className={`w-100 rounded-3 py-2 fs-16 ${plan.isPremium ? "fw-bold" : ""} ${isActionDisabled ? "text-grey" : ""}`}
                            variant={isActionDisabled ? "additional-grey" : plan.action.variant}
                            disabled={isActionDisabled}
                            onClick={() => onClickAction?.(plan)}
                        >
                            {plan.action.text}
                        </Button>
                    ) : null}
                </div>
            </Card.Body>
        </Card>
    );
};

export default TariffPlanCard;
